import { render, staticRenderFns } from "./systemNotice.vue?vue&type=template&id=34b54914&scoped=true&"
import script from "./systemNotice.vue?vue&type=script&lang=js&"
export * from "./systemNotice.vue?vue&type=script&lang=js&"
import style0 from "./systemNotice.vue?vue&type=style&index=0&id=34b54914&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b54914",
  null
  
)

export default component.exports